<template>
	<div class="product-box">
		<van-image class="title" :src="titleImg"/>
		<van-swipe :loop="false" ref="proSwipe" @change="onChange">
			<van-swipe-item v-for="(item,index) in productList" :key="index">
				<van-image :src="item.imgSrc"/>
			</van-swipe-item>
			<template #indicator>
				<van-slider class="custom-indicator" v-model="sliderIndex" active-color="#4d4d4d" inactive-color="#bfbfbf" disabled :min="0" :max="4" >
					<template #button>
						<div class="custom-button"></div>
					</template>
				</van-slider>
			</template>
		</van-swipe>
		<div class="leftArrow" @click="Prev"></div>
		<div class="rightArrow" @click="Next"></div>
		<van-image class="more" :src="moreImg" @click="showSecond(current)"/>
		<van-popup class="detail-box" :overlay="false" :get-container="getContainer" v-model="showDetail" >
			<!-- <van-image class="detail-img" :src="detailImgSrc"/> -->
			<div class="flex-list" v-if="detailImgList.length>0">
				<div class="flex-item" v-for="(item,subIndex) in detailImgList" :key="subIndex">
					<img :src="item.imgSrc"/>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import { eventBus } from '@/main.js'
	export default {
		name: 'm_Product',
		data() {
			return {
				// swperValue:1,
				current: 0,
				showDetail: false,
				titleImg: require("../../../static/m/product/title.png"),
				detailImgSrc: require("../../../static/m/product/detail-01.png"),
				productList: [
					{
						imgSrc:require("../../../static/m/product/pro-img-01.png"),
						detailImgSrc:require("../../../static/m/product/detail-01.png"),
						detailImgList:[
							{
								imgSrc:require("../../../static/m/product/detail-01_1.png"),
							},{
								imgSrc:require("../../../static/m/product/detail-01_2.png"),
							},{
								imgSrc:require("../../../static/m/product/detail-01_3.png"),
							},{
								imgSrc:require("../../../static/m/product/detail-01_4.png"),
							}
							
						]
					},
					{
						imgSrc:require("../../../static/m/product/pro-img-02.png"),
						detailImgSrc:require("../../../static/m/product/detail-02.png"),
						detailImgList:[
							{
								imgSrc:require("../../../static/m/product/detail-02_1.png"),
							},{
								imgSrc:require("../../../static/m/product/detail-02_2.png"),
							},{
								imgSrc:require("../../../static/m/product/detail-02_3.png"),
							}
							
						]
					},
					{
						imgSrc:require("../../../static/m/product/pro-img-03.png"),
						detailImgSrc:require("../../../static/m/product/detail-03.png"),
						detailImgList:[
							{
								imgSrc:require("../../../static/m/product/detail-03_1.png"),
							},{
								imgSrc:require("../../../static/m/product/detail-03_2.png"),
							}
						]
					},
					{
						imgSrc:require("../../../static/m/product/pro-img-04.png"),
						detailImgSrc:require("../../../static/m/product/detail-04.png"),
						detailImgList:[
							{
								imgSrc:require("../../../static/m/product/detail-04_1.png"),
							},{
								imgSrc:require("../../../static/m/product/detail-04_2.png"),
							}
							
						]
					}
				],
				moreImg: require("../../../static/m/common/more-dark.png"),
				detailImgList:[],
			}
		},
		props:{
			subActiveIndex:{
				type:Number,
				default: 0
			}
		},
		computed: {
			sliderIndex: function () {
				return this.current+1
			}
		},
		watch:{
			subActiveIndex(){
				this.$refs.proSwipe.swipeTo(this.subActiveIndex)
			}
		},
		methods: {
			onChange(index) {
				this.current = index;
			},
			showSecond() {
			    this.$store.commit("setBgColor", '#e5e3e1');
				this.showDetail = true;
				this.detailImgSrc = this.productList[this.current].detailImgSrc;
				this.detailImgList = this.productList[this.current].detailImgList;
				this.$store.commit("setSecondPage", true);
			},
			Prev() {
				// this.$refs.proSwipe.prev()
			},
			Next() {
				// this.$refs.proSwipe.next()
			},
			getContainer() {
				// console.log(document.querySelector('.m-pageSwiper'))
				return document.querySelector('.m-pageSwiper');
			},
			// onClickCloseIcon(){
			// 	console.log("close product")
			// 	this.showDetail = false;
			// 	this.$store.commit("setSecondPage", false);
			// }
		},
		mounted() {
			var that = this;
			if (this.subActiveIndex) {
				this.$refs.proSwipe.swipeTo(this.subActiveIndex)
			}
			//监听事件
			eventBus.$on('closeSecondPage', (index) => {
				if(index == 1){
					that.showDetail = false;
					that.$store.commit("setSecondPage", false);
				}
				// that.showDetail = false;
				// // that.onClickCloseIcon();
				// that.$store.commit("setSecondPage", false);
			});
		}
	}
</script>

<style lang="less" scoped>
@import url('@/assets/css/index.less');
	.product-box {
		background-color: #eeede9;
		width: 100%;
		height: 100%;
	}
	.title {
		.scale(314,172);
		.pos-a(220,159,99);
	}
	.leftArrow {
		position: absolute;
		bottom: 518/@r;
		z-index: 99;
		left:96/@r;
		.scale(24,42);
		background-image: url('../../../static/m/product/arrow.png');
		background-size: 933/@r 42/@r;
		background-position: 0 0;
	}
	.rightArrow {
		position: absolute;
		bottom: 518/@r;
		z-index: 99;
		left:1007/@r;
		.scale(24,42);
		background-image: url('../../../static/m/product/arrow.png');
		background-size: 933/@r 42/@r;
		background-position: -909/@r 0;
	}
	.more {
		.scale(825,108);
		position: absolute;
		bottom: 280/@r;
		z-index: 99;
		left: 50%;
		transform: translateX(-50%);
	}
	.van-swipe-item {
		margin-top: 160/@r;
	}
	.custom-indicator {
		position: absolute;
		width: 825/@r;
		bottom: 538/@r;
		left: 50%;
		transform: translateX(-50%);
		opacity: 1;
		.custom-button {
			background-color: #4d4d4d !important;
			opacity: 0;
		}
	}
	.close {
		color:black;
	}
	.detail-box {
		background-color: #e5e3e1;
		width:100%;
		height:100%;
		display: block;
		/deep/.van-popup__close-icon {
			font-size: 30px;
			color:#4d4d4d;
		}
		.detail-img {
			margin-bottom: 200/@r;
		}
	}
	.flex-list{
		  display: flex;
		  flex-wrap: wrap;
		  width: 100%;
		  padding-bottom: 200/@r;
		  .pos-a(0, 0, 4);
		  .flex-item{
			  width: 100%;
		  }
	}
</style>